import { useGetQuery } from '@/hooks/api/useGetQuery';
import { queryKeys } from './query-keys';

export function useFestivalDetailQuery(festivalId: string | undefined) {
  return useGetQuery(
    () => `/admin/festival/${festivalId}`,
    {},
    queryKeys.festival(festivalId),
    {
      enabled:
        festivalId !== undefined &&
        festivalId !== '' &&
        !Number.isNaN(Number(festivalId)),
      retry: false,
    },
  );
}
